// src/features/places/marketRecord.js
//
// PLACES-SLICE-2: market record (city record) tab contract + governance.
// Exactly four record tabs; each is governed by its corresponding Places
// lens. The record itself is reached through the "plan" gate, which already
// resolves to Places parent + Markets lens (see governedNavEnabled).

import { resolvePlacesLens } from "../../app/places.js";

export const MARKET_RECORD_TABS = Object.freeze([
  { key: "overview", label: "Overview", lens: "markets" },
  { key: "offices",  label: "Offices",  lens: "offices" },
  { key: "pressure", label: "Pressure", lens: "pressure" },
  { key: "scenario", label: "Scenario", lens: "scenario" },
]);

export function enabledMarketRecordTabs(placesTabs) {
  return MARKET_RECORD_TABS.filter((tab) => resolvePlacesLens(tab.lens, placesTabs) === tab.lens);
}

export function buildMarketRecordUrl(marketId, tab = "overview") {
  const params = new URLSearchParams({ peek: marketId });
  const drawerTab = ["pressure", "scenario", "capacity"].includes(tab) ? "capacity" : tab;
  if (["plan", "capacity", "media"].includes(drawerTab)) params.set("peekTab", drawerTab);
  return `/places/markets?${params}`;
}

// Return to the collection, not the record that was open when it was left.
export function marketListReturnPath(pathname, search = "", hash = "") {
  const params = new URLSearchParams(search);
  params.delete("expandMarket");
  params.delete("peek");
  params.delete("peekTab");
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ""}${hash}`;
}

export function marketStateFromOffice(state) {
  return state?.marketRecordState ?? {
    returnPath: state?.marketReturnPath ?? "/places/markets",
  };
}

// Return context: only Places, office, and market-record paths are honoured
// as explicit back targets; anything else falls back to the stored lens.
export function marketRecordBack(returnPath) {
  if (typeof returnPath !== "string" || !returnPath.startsWith("/")) return null;
  if (returnPath.startsWith("/places/")) {
    const lens = /^\/places\/(\w+)/.exec(returnPath)?.[1];
    return { path: returnPath, label: { offices: "Offices", markets: "Markets", pressure: "Pressure", scenario: "Scenario" }[lens] ?? "Places" };
  }
  if (returnPath.startsWith("/offices/") || /^\/places\/offices\/[^/?#]+/.test(returnPath)) return { path: returnPath, label: "Office" };
  return null;
}
